import * as THREE from 'three';

const canvas = document.getElementById('gl-canvas') as HTMLCanvasElement | null;
if (!canvas) throw new Error('gl-canvas not found');

const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.1, 100);
camera.position.set(0, 2, 12);
camera.lookAt(0, -2, 0);

const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.setSize(window.innerWidth, window.innerHeight);

// Large wireframe plane, angled slightly
const SIZE = 24;
const SEGS = 64;
const geo = new THREE.PlaneGeometry(SIZE, SIZE, SEGS, SEGS);
const mat = new THREE.MeshBasicMaterial({
  color: 0xe5ac41,
  wireframe: true,
  transparent: true,
  opacity: 0.10,
  depthWrite: false,
});
const plane = new THREE.Mesh(geo, mat);
plane.rotation.x = -Math.PI / 2;
plane.position.y = -3;
scene.add(plane);

// Get original vertex positions for animation
const orig = new Float32Array(geo.attributes.position.array);

function onResize() {
  renderer.setSize(window.innerWidth, window.innerHeight);
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
}
window.addEventListener('resize', onResize);

let t = 0;
function animate() {
  requestAnimationFrame(animate);
  t += 0.01;

  const pos = geo.attributes.position.array as Float32Array;
  for (let i = 0; i < pos.length; i += 3) {
    const ox = orig[i];
    const oy = orig[i + 1];
    pos[i + 2] = Math.sin(ox * 0.6 + t) * Math.cos(oy * 0.6 + t * 0.8) * 2.5;
  }
  geo.attributes.position.needsUpdate = true;

  renderer.render(scene, camera);
}
animate();
